<template>
  <p>
    El disdrómetro óptico registra el diámetro y la velocidad de caída de las
    partículas de precipitación. El instrumento emite una señal láser desde un
    cabezal al otro para medir el diámetro de las gotas; desde muy pequeñas
    0.312 mm (comúnmente llovizna) hasta 24.5 mm (comúnmente copos de nieve). La
    relación entre el diámetro y la velocidad de las partículas son únicas y son
    usadas para clasificar un tipo de precipitación (lluvia, llovizna, nevada,
    graupel, granizo).
  </p>
  <p>
    La detección y diferenciación de partículas sólidas y líquidas, ayuda a
    comprender fenómenos atmosféricos como la formación de granizo y la
    transición entre lluvia y nieve.
  </p>
  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/disdrometro.webp"
    alt="Disdrómetro"
  />

  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>Intensidad de precipitación (mm/h)</li>
    <li>SYNOP_4680 / Código de tipo de precipitación</li>
    <li>Reflectividad (dBz)</li>
    <li>Energía Cinética (J/(m<sup>2</sup> h)</li>
    <li>
      N(d) Promedio del volumen equivalente del diámetro (log<sub>10</sub>
      1/m<sup>3</sup> mm)
    </li>
    <li>v(d) Promedio de velocidad de caída (m/s)</li>
  </List>

  <p>
    <b>Marca y modelo: </b> <br />
    OTT Hydromet, Parsivel2
  </p>

  <p>
    <b>País: </b> <br />
    Alemania.
  </p>

  <p>
    <b>Especificaciones técnicas: </b> <br />
    <a
      href="https://www.ott.com/es-la/productos/meteorologia-80/ott-parsivel2-272/"
      target="_blank"
      >https://www.ott.com/es-la/productos/meteorologia-80/ott-parsivel2-272/</a
    >
  </p>

  <p>
    <b>Responsable: </b> <br />
    jflores@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
  components: { List },
};
</script>
